// extracted by mini-css-extract-plugin
export default {"blank_result_label":"styles_blank_result_label__EMePz","review_result_label":"styles_review_result_label__+Ft3p"};